import React, { Component } from "react";
import { connect } from "react-redux";
import { CloseIcon } from "../common/icons/svg";
import { color } from "../common/constants";
import { renderImg } from "../common/icons/img";
let counter = 1;

class InputPastHistroy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      focus: this.props.tab == 7 && this.props.navTab == 'passengerlist' ? true : false,
      blur: false,
      LocalList: [],
    };
  }
  componentDidMount() {
    let LocalList = JSON.parse(localStorage.getItem("userinfotable")) || [];
    // LocalList = [["", "", ""], ["mohan singh", 25, "M"], ["sohan singh", 28, "M"], ["testwww", 29, "Female"], ["josh ", 28, "Male"], ["pestee", 28, "Female"]];
    this.setState({ LocalList })

    setTimeout(() => {
      if (this.state.autoFocus) {
        this.filterAutoFill(this.props.seatno);
      }
    }, 300)
  }

  getBorderColor = () => {
    if (this.state.focus) {
      return color.primary;
    }
    if (this.state.blur) {
      if (!this.props.value || this.props.value === "") {
        return "red";
      }
    }
    return "#ddd";
  };
  handleKeyPress = (event) => {
    if (this.state.focus) {
      if (event.key === "ArrowDown") {
        if (this.refs["atc" + (counter + 1)]) counter++;
        if (this.refs["atc" + (counter - 1)] && this.refs["atc" + counter])
          this.refs["atc" + (counter - 1)].style = "";
        if (this.refs["atc" + counter]) {
          this.refs["atc" + counter].style = "background:#e5e5e5";
          this.refs.atc.scrollTop = (counter - 1) * 37;
        }
      }
      if (event.key === "ArrowUp") {
        if (counter !== 1) counter--;
        if (this.refs["atc" + (counter + 1)] && this.refs["atc" + counter])
          this.refs["atc" + (counter + 1)].style = "";
        if (this.refs["atc" + counter]) {
          this.refs["atc" + counter].style = "background:#e5e5e5";
          this.refs.atc.scrollTop = (counter - 1) * 37;
        }
      }
      if (event.key === "Enter") {
        // console.log("this.ref", this.refs["atc" + counter].textContent)
        let active = document.activeElement;
        let allElements = document.querySelectorAll('[tabindex]');
        let target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 1);
        if (this.refs["atc" + counter] && this.refs["atc" + counter].textContent) {
          let entry = this.refs["atc" + counter].textContent.split(",");
          entry[1] = parseInt(entry[1], 10);
          entry[2] = entry[2].replace(/\s/g, "");
          entry[3] = entry[3] && entry[3].trim();
          this.props.handleSelect(entry, this.props.seatno, this.props.triptype);
          this.setState({ focus: false });
          counter = 1;
          target = Array.from(allElements).find(el => el.tabIndex === active.tabIndex + 4);
          if (target) {
            target.focus();
          }
        }
        // Focus the next element if it exists
        if (target) {
          target.focus();
        }
      }
    }
  };

  storeInLocal = () => {
    let userprops = this.props.search.order;
    let onwarduserinfo = userprops.onward.seatDetails;
    let userinfotable = this.state.LocalList;//JSON.parse(localStorage.getItem("userinfotable"));
    userinfotable = userinfotable ? userinfotable : [];
    Object.keys(onwarduserinfo).map((el) => {
      if (
        !this.isInLocalList([
          onwarduserinfo[el].name,
          onwarduserinfo[el].age,
          onwarduserinfo[el].gender,
          onwarduserinfo[el].concessionType,
          onwarduserinfo[el].idCardType,
          onwarduserinfo[el].idCardNo,
          onwarduserinfo[el].nationality,
        ])
      ) {
        userinfotable.push([
          onwarduserinfo[el].name,
          onwarduserinfo[el].age,
          onwarduserinfo[el].gender,
          onwarduserinfo[el].concessionType,
          onwarduserinfo[el].idCardType,
          onwarduserinfo[el].idCardNo,
          onwarduserinfo[el].nationality,
        ]);
      }
    });
    if (userprops.return && userprops.return.seatDetails) {
      let returnUserInfo = userprops.return.seatDetails;
      Object.keys(returnUserInfo).map((el) => {
        if (
          !this.isInLocalList([
            returnUserInfo[el].name,
            returnUserInfo[el].age,
            returnUserInfo[el].gender,
            returnUserInfo[el].concessionType,
            returnUserInfo[el].idCardType,
            returnUserInfo[el].idCardNo,
            returnUserInfo[el].nationality,
          ])
        ) {
          userinfotable.push([
            returnUserInfo[el].name,
            returnUserInfo[el].age,
            returnUserInfo[el].gender,
            returnUserInfo[el].concessionType,
            returnUserInfo[el].idCardType,
            returnUserInfo[el].idCardNo,
            returnUserInfo[el].nationality,
          ]);
        }
      });
    }
    userinfotable = userinfotable.slice(Math.max(userinfotable.length - 6, 0));
    this.setState({ LocalList: userinfotable })
    window.localStorage.setItem("userinfotable", JSON.stringify(userinfotable));
  };

  isInLocalList(passengerentry) {
    // let LocalList = JSON.parse(localStorage.getItem("userinfotable")) || [];
    let LocalList = this.state.LocalList;
    LocalList.map((el) => { });
    for (var i = 0; i < LocalList.length; i++) {
      if (this.checkequality(passengerentry, LocalList[i])) {
        return true;
      }
    }
    return false;
  }

  showDropDown = () => {
    // let LocalList = JSON.parse(localStorage.getItem("userinfotable")) || [];
    let LocalList = this.state.LocalList;
    if (LocalList.length > 0) {
      const uniqueData = [];
      const namesSeen = new Set();

      for (const entry of LocalList) {
        const name = entry[0]; // The name is the first element of each inner array
        if (!namesSeen.has(name)) {
          uniqueData.push(entry);  // Add the entry to the uniqueData array
          namesSeen.add(name);     // Mark the name as seen
        }
      }
      return (
        <div className="dropdownpast">
          <div className="pastlist" ref="atc">
            {/* {this.showAtc(LocalList)} */}
            {this.showAtc(uniqueData)}
          </div>
        </div>
      );
    }
  };
  setEntry = (entry) => {
    this.props.handleSelect(entry, this.props.seatno, this.props.triptype);
    this.setState({ focus: false });
  };

  showAtc = (list) => {
    let i = 0;
    const order = this.props.search.order;
    let onwardlist = order.onward.seatDetails;
    let returnlist = order.return && order.return.seatDetails;
    let onwardarray = [];
    let returnarray = [];
    let currentname = this.props.value;
    currentname = currentname ? currentname.toLowerCase() : "";

    Object.entries(onwardlist).map((el) => {
      onwardarray.push([el[1].name, el[1].age, el[1].gender, el[1].concessionType, el[1].idCardType, el[1].idCardNo, el[1].nationality]);
    });

    order.return && order.return.seatDetails && Object.entries(returnlist).map((el) => {
      returnarray.push([el[1].name, el[1].age, el[1].gender, el[1].concessionType, el[1].idCardType, el[1].idCardNo, el[1].nationality]);
    });

    let filterData = list;
    if (this.props.triptype == 'onward') {
      let order = this.props.search.order;
      let seatDetails = order.onward.seatDetails;
      let gender = seatDetails[this.props.seatno].gender === 'F' ? 'Female' : seatDetails[this.props.seatno].gender;

      if (gender == 'Female') {
        filterData = list.filter(el => el[2] === 'Female');
      }
    }

    list = filterData;


    return list.map((el, index) => {
      if (el[0] && el[0].toLowerCase().indexOf(currentname) === 0) {
        if (this.props.triptype === 'onward') {
          if (!this.isInList(el, onwardarray)) {
            i++;
            return (
              <React.Fragment>
                {i === 1 ? (
                  <div className="dropdownhead" style={{ cursor: "default" }}>
                    Select from past or type new passenger
                  </div>
                ) : (
                  ""
                )}
                <div
                  className={`flexed-justify ${currentname && currentname.length > 0 ? 'active' : ''}`}
                  key={index}
                  ref={"atc" + i}
                  onClick={() => this.setEntry(el)}
                >
                  {el[0] + ", " + el[1] + ", " + el[2] + ", " + (el[3] ? el[3] + ", " : '') + (el[4] ? el[4] + ", " : '') + (el[5] ? el[5] + ", " : '') + el[6]}

                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      this.deletefrompasthistory(index);
                    }}
                  >
                    {/* <CloseIcon /> */}
                    {(currentname && currentname.length > 0) ? renderImg('CloseIconActive') : renderImg('CloseIcon')}
                  </span>
                </div>
              </React.Fragment>
            );
          }
          else {
            return "";
          }
        }
        if (this.props.triptype === 'return' && order.return && order.return.seatDetails) {
          if (!this.isInList(el, returnarray)) {
            i++;
            return (
              <React.Fragment>
                {i === 1 ? (
                  <div className="dropdownhead" style={{ cursor: "default" }}>
                    Select from past or type new passenger
                  </div>
                ) : (
                  ""
                )}
                <div
                  className="flexed-justify"
                  key={index}
                  ref={"atc" + i}
                  onClick={() => this.setEntry(el)}
                >
                  {el[0] + ", " + el[1] + ", " + el[2] + ", " + (el[3] ? el[3] + ", " : '') + (el[4] ? el[4] + ", " : '') + (el[5] ? el[5] + ", " : '') + el[6]}
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      this.deletefrompasthistory(index);
                    }}
                  >
                    {/* <CloseIcon /> */}
                    {renderImg('CloseIcon')}
                  </span>
                </div>
              </React.Fragment>
            );
          }
          else {
            return "";
          }
        }
      } else {
        return "";
      }
    });
  };
  isInList(item, list) {
    for (var i = 0; i < list.length; i++) {
      if (this.checkequality(item, list[i])) {
        return true;
      }
    }
    return false;
  }
  checkequality(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
      return false;
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      if (a[propName] !== b[propName]) {
        return false;
      }
    }
    if (a.length !== 0) {
      return true;
    } else {
      return false;
    }
  }
  deletefrompasthistory(item) {
    let userinfotable = this.state.LocalList;//JSON.parse(localStorage.getItem("userinfotable"));
    userinfotable = this.deleteRow(userinfotable, item);
    userinfotable = userinfotable ? userinfotable : [];
    this.setState({ LocalList: userinfotable })
    window.localStorage.setItem("userinfotable", JSON.stringify(userinfotable));
  }
  deleteRow(arr, row) {
    arr = arr.slice(0); // make copy
    arr.splice(row, 1);
    return arr;
  }

  filterAutoFill = (seatno = '') => {
    const order = this.props.search.order;
    let onwardlist = order.onward.seatDetails;
    let returnlist = order.return && order.return.seatDetails;
    let LocalList = this.state.LocalList;
    let filterList = [];

    LocalList = LocalList.map(el => {
      if (el[2] === 'M' || el[2] === 'Male') {
        el[2] = 'Male';
      } else if (el[2] === 'F' || el[2] === 'Female') {
        el[2] = 'Female';
      } else {
        el[2] = el[2];
      }
      return el;
    })
    if (this.props.triptype === 'onward') {
      let gender = onwardlist[this.props.seatno || seatno].gender;
      if (gender !== '') {
        filterList = LocalList.filter((el) => {
          if (el.includes(gender)) {
            return el;
          }
        })
      } else {
        filterList = this.state.LocalList;
      }
    }

    if (this.props.triptype === 'return' && returnlist) {
      let gender = returnlist[this.props.seatno].gender;
      // console.log('returnlist', returnlist[this.props.seatno]);
      if (gender !== '') {
        filterList = LocalList.filter((el) => {
          if (el.includes(gender)) {
            return el;
          }
        })
      } else {
        filterList = this.state.LocalList;
      }
    }

    this.setState({ LocalList: filterList })
  }

  setFocus = () => {
    if (this.props.name === 'paxName2[0]') {
      this.storeInLocal();
    }
    this.filterAutoFill();
    this.setState({ focus: true, blur: false })
  }
  render() {
    return (
      <div
        style={{ ...this.props.style }}
        className={this.props.className ? this.props.className : "relativepos"}
      >
        <input
          type="password"
          name="password"
          style={{
            position: "absolute",
            opacity: 0,
            height: "0px",
            width: "0px",
            margin: "0px",
            padding: "0px",
          }}
        />
        <input
          type="text"
          name={this.props.name}
          placeholder={this.props.placeholder}
          value={this.props.value}
          tabIndex={this.props.tab}
          autoFocus={this.props.tab === 1 || this.props.autoFocus}
          maxLength={this.props.max}
          autoComplete="none"
          readOnly={this.props.readOnly}
          disabled={this.props.disabled}
          pattern={this.props.pattern}
          onChange={(event) =>
            this.props.handleChange(
              this.props.filedname,
              this.props.triptype,
              this.props.seatno,
              event.target.value
            )
          }
          onFocus={() => { this.setFocus(); this.props.toggleDrop && this.props.toggleDrop() }}
          onBlur={() =>
            setTimeout(() => {
              this.setState({ focus: false, blur: true });
            }, 500)
          }
          onKeyDown={this.handleKeyPress}
          className="ty-text"
          style={{
            background: "transparent",
            borderWidth: !this.state.focus && !this.state.blur ? "1px" : "2px",
            borderStyle: "solid",
            borderColor: this.getBorderColor(),
            outline: 0,
            width: "100%",
            padding: this.props.isImg ? "20px 0 5px 40px" : "18px 10px",
            transition: "0.3s ease",
            borderRadius: this.props.InputRadius || "6px",
            height: this.props.InputHeight || "45px",
          }}
        />
        <label
          style={{
            position: "absolute",
            left: "7px",
            fontSize:
              this.state.focus || (this.props.value + "").length > 0
                ? "0.7em"
                : "inherit",
            bottom:
              this.state.focus || (this.props.value + "").length > 0
                ? "38px"
                : "15px",
            transition: "0.3s ease",
            pointerEvents: "none",
            color: this.state.focus ? color.primary : "inherit",
            padding: "0 5px",
            background: "#fff",
          }}
        >
          {this.props.placeholder}
        </label>
        {this.state.focus ? this.showDropDown() : ""}
      </div>
    );
  }

  inpS = {
    width: "100%",
    background: this.props.err ? "rgba(255, 0, 0, 0.2)" : "#fff",
    //padding: this.state.focus ? this.props.inputpadding : "15px",
    border: "0",
    outline: "0",
    borderRight: this.props.inputborder
      ? this.props.inputborder
      : "1px solid #ddd",
  };
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(InputPastHistroy);